<template>
  <div class="pa-4 pb-0">
    <div class="text-center" v-if="selectedRiver">
      <v-row no-gutters justify="end" class="px-2" style="font-size: 10px">
        <div
          class="py-1 px-2"
          style="background-color: whitesmoke; border-radius: 5px"
        >
          <span style="font-size: 12px">年超過確率</span>
          <span v-if="$vuetify.breakpoint.lgAndUp"
            >&nbsp;&nbsp;&nbsp;&nbsp;</span
          >
          <br v-else />
          <span v-for="color in colors" :key="color.level">
            <v-icon :color="color.code">mdi-minus</v-icon>
            <span>{{ color.level }}</span>
          </span>
        </div>
      </v-row>
      <div class="font-weight-bold mt-2">
        <h3>{{ selectedRiver.name }}</h3>
      </div>
      <v-carousel
        v-model="tab"
        hide-delimiters
        hide-delimiter-background
        height="max-content"
        :show-arrows="false"
        class="px-2"
      >
        <v-carousel-item>
          <v-sheet tile>
            <v-row no-gutters align="center" class="px-4">
              <v-col class="px-1" :cols="$vuetify.breakpoint.lgAndUp ? '' : 12">
                <bar-chart :river="selectedRiver" />
              </v-col>
              <v-col
                class="px-1"
                :cols="$vuetify.breakpoint.lgAndUp ? '' : 12"
                style="position: relative"
              >
                <boxplot-chart :river="selectedRiver" />
                <v-btn
                  v-if="$vuetify.breakpoint.lgAndUp"
                  fab
                  dark
                  depressed
                  x-small
                  color="rgba(0, 0, 0, 0.3)"
                  style="position: absolute; top: 43px; right: 25px"
                  @click="showDetail"
                >
                  <v-icon size="30"> mdi-chevron-right </v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-btn
              v-if="$vuetify.breakpoint.lgAndUp"
              class="mt-4 mb-2"
              x-small
              depressed
              @click="isShow = !isShow"
            >
              {{ isShow ? "全水系非表示" : "全水系表示" }}
            </v-btn>
          </v-sheet>
        </v-carousel-item>
        <v-carousel-item>
          <v-sheet class="mb-4">
            <v-btn
              icon
              x-large
              color="rgba(0, 0, 0, 0.3)"
              style="position: absolute; top: 190px; left: 0"
              @click="showMain"
            >
              <v-icon x-large> mdi-chevron-left </v-icon>
            </v-btn>
            <v-row no-gutters justify="center">
              <div style="width: 50%">
                <boxplot-chart :river="selectedRiver" />
              </div>
            </v-row>
            <v-row no-gutters justify="center">
              <div style="width: 50%">
                <line-chart :river="selectedRiver" :key="selectedRiver.id" />
              </div>
            </v-row>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
    <v-divider class="my-2"></v-divider>
    <v-virtual-scroll
      v-if="isShow"
      :height="400"
      :items="rivers"
      :item-height="120"
    >
      <template v-slot:default="{ item }">
        <div>
          <v-row no-gutters align="center" class="mb-4 pa-4 text-center">
            <v-col cols="1" class="font-weight-bold">
              {{ item.name }}
            </v-col>
            <v-col class="px-2">
              <bar-chart :river="item" />
            </v-col>
            <v-col class="px-2">
              <boxplot-chart :river="item" />
            </v-col>
          </v-row>
        </div>
      </template>
    </v-virtual-scroll>
  </div>
</template>

<script>
import BoxplotChart from "@/components/risk-map-view/BoxplotChart.vue";
import BarChart from "@/components/risk-map-view/BarChart";
import LineChart from "@/components/risk-map-view/LineChart";
const COLORS = [
  {
    level: "1/10",
    code: "#238100",
  },
  {
    level: "1/30",
    code: "#FEFF54",
  },
  {
    level: "1/50",
    code: "#FF8038",
  },
  {
    level: "1/100",
    code: "#ff1300",
  },
  {
    level: "1/150",
    code: "#f027ff",
  },
  {
    level: "1/200",
    code: "#880088",
  },
  {
    level: "想定最大規模",
    code: "#000000",
  },
];

export default {
  name: "RainEnsembleChartDialog",
  props: ["selectedRiver", "rivers"],
  components: {
    LineChart,
    BarChart,
    BoxplotChart,
  },
  data() {
    return {
      isShow: false,
      completed: 0,
      colors: COLORS,
      tab: 0,
    };
  },
  methods: {
    showMain() {
      this.tab = 0;
    },
    showDetail() {
      this.isShow = false;
      this.tab = 1;
    },
  },
};
</script>
<style>
.row + .row {
  margin: 0;
}
</style>
